import React from "react";
import { useTranslation } from "react-i18next";
import Icon from "../../components/Icon";

export default function IntegrationBuilderUrlInput({ url, setUrl, onSubmit }) {
    const { t } = useTranslation();
    return (
        <div className="max-w-xl mx-auto py-12 space-y-6">
            <div className="text-center space-y-2">
                <div className="inline-flex items-center justify-center w-14 h-14 bg-blue-100 rounded-full mb-2">
                    <Icon name="Globe" className="w-7 h-7 text-blue-600" />
                </div>
                <h2 className="text-xl font-bold text-gray-900">{t("builder.urlInput.title")}</h2>
                <p className="text-sm text-gray-500 max-w-md mx-auto">{t("builder.urlInput.description")}</p>
            </div>

            <div className="bg-white border rounded-lg p-5 space-y-4">
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">{t("builder.urlInput.label")}</label>
                    <input
                        type="url"
                        value={url}
                        onChange={(e) => setUrl(e.target.value)}
                        placeholder="https://docs.example.com/api/reference"
                        className="w-full px-4 py-3 border rounded-lg text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                        onKeyDown={(e) => e.key === "Enter" && onSubmit()}
                        autoFocus
                    />
                </div>
                <div className="flex flex-wrap gap-2 text-xs text-gray-400">
                    <span className="flex items-center gap-1"><Icon name="Check" className="w-3 h-3" /> REST APIs</span>
                    <span className="flex items-center gap-1"><Icon name="Check" className="w-3 h-3" /> GraphQL APIs</span>
                    <span className="flex items-center gap-1"><Icon name="Check" className="w-3 h-3" /> OpenAPI/Swagger</span>
                    <span className="flex items-center gap-1"><Icon name="Check" className="w-3 h-3" /> Postman</span>
                </div>
                <button
                    onClick={onSubmit}
                    disabled={!url}
                    className={`w-full py-3 rounded-lg text-white font-medium flex items-center justify-center gap-2 ${url ? "bg-blue-600 hover:bg-blue-700" : "bg-gray-300 cursor-not-allowed"}`}
                >
                    <Icon name="Sparkles" className="w-4 h-4" />
                    {t("builder.urlInput.analyzeButton")}
                </button>
            </div>
        </div>
    );
}
